import React from 'react';

import ProjectNameHeader from '../project-name-header/ProjectNameHeader';
import { ICONS } from '../../../icons';

function Activ8Header() {
  return <ProjectNameHeader icon={ICONS.Activ8} defaultName='ACTIV8' selector={(state) => state.activ8?.projectName} />;
}

export default Activ8Header;
